"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderingBenefitsClub',
  props: {
    // 属性定义
  },
  data: function data() {
    return {};
  },
  computed: {
    // 计算属性
  },
  methods: {
    // 方法定义
  },
  mounted: function mounted() {
    // 生命周期钩子
  }
};